import React from "react";
import PropTypes from "prop-types";
import { Editor } from "@tinymce/tinymce-react";

function decodeHtmlEntities(str) {
    if (!str) return "";

    const txt = document.createElement("textarea");
    txt.innerHTML = str;
    return txt.value;
}

class HTMLEditorTinyMCE extends React.Component {

    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(content) {
        const { onChange } = this.props;

        if (onChange) {
            onChange(content);
        }
    }

    render() {

        const {
            texto,
            height,
            backgroundColor
        } = this.props;

        const textoDecodificado =
            decodeHtmlEntities(texto);

        return (
            <div style={{ backgroundColor }}>
                <Editor
                    value={textoDecodificado || ""}
                    onEditorChange={this.handleChange}
                    init={{
                        height: height || 300,
                        menubar: false,

                        plugins: [
                            "lists",
                            "link",
                            "image",
                            "table",
                            "code"
                        ],

                        toolbar:
                            "undo redo | bold italic underline | " +
                            "forecolor backcolor | " +
                            "alignleft aligncenter alignright | " +
                            "bullist numlist | removeformat | code",

                        forced_root_block: "p",

                        content_style:
                            "body { font-family: Arial; font-size: 14px; }"
                    }}
                />
            </div>
        );
    }
}

HTMLEditorTinyMCE.propTypes = {
    texto: PropTypes.string,
    onChange: PropTypes.func,
    height: PropTypes.number,
    backgroundColor: PropTypes.string
};

export default HTMLEditorTinyMCE;